import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";
import { PdfFiltersEnum } from "../../../features/Library/Pdfs/types/models";

export const getPdfsFilters = (
  includePublisher: boolean = true,
  disableDateFilters: boolean = false,
): FilterItemBase<PdfFiltersEnum>[] => {
  let filters: FilterItemBase<PdfFiltersEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: PdfFiltersEnum.DateCreated,
      otherProps: { disabled: disableDateFilters },
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: PdfFiltersEnum.DateModified,
      otherProps: { disabled: disableDateFilters },
    },
  ];

  if (includePublisher) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: PdfFiltersEnum.Publishers,
      placeholder: "All Publishers",
    });
  }

  filters.push(
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: PdfFiltersEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: PdfFiltersEnum.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: PdfFiltersEnum.Labels,
      placeholder: "All Labels",
    },
  );

  return filters;
};
